import ResponsiveAppBar from "../../../layouts/navbar";
import { Footer } from "../../../layouts/footer";
import { LoginPart } from "./login";
const LoginPage = () => {
  return (
    <>
      <div id="wrapper">
        <ResponsiveAppBar />
        <div className="tf-page-title style-3">
          <div className="container-full">
            <div className="heading text-center">Log in</div>
          </div>
        </div>

        <section className="flat-spacing-10">
          <div className="container">
            <div className="tf-grid-layout lg-col-2 tf-login-wrap">
              <div className="tf-login-form">
                <div id="login">
                  <h5 className="mb_36">Log in</h5>
                  <div>
                    <LoginPart />
                  </div>
                </div>
              </div>
              <div className="tf-login-content">
                <h5 className="mb_36">I'm new here</h5>
                <p className="mb_20">
                  Delivering Freshly Baked Delights to Your Doorstep,
                  <br /> Bringing the Best Baked Goods Right to Your Home
                </p>
                <a href="register.html" className="tf-btn btn-line">
                  Home<i className="icon icon-arrow1-top-left"></i>
                </a>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default LoginPage;
